window.sectionRenderers = window.sectionRenderers || {};

window.sectionRenderers.videoText = function (data) {
  const hasVideo = !!data.videoUrl;
  const hasText = !!(data.title || data.description);
  if (!hasVideo && !hasText) return "";

  const layoutClass =
    data.layout === "left" ? "cs-media-text--left" : "cs-media-text--right";
  const videoTitle = data.videoTitle || "";
  const speakerIconUrl = (window.csIconUrls && window.csIconUrls.speaker) || "";
  const muteIconUrl = (window.csIconUrls && window.csIconUrls.mute) || "";
  const fullScreenIconUrl =
    (window.csIconUrls && window.csIconUrls.fullScreen) || "";
  const mediaHtml = hasVideo
    ? '<div class="cs-media-text__media cs-media-text__media--video" onclick="toggleCsVideoFromMedia(event)">' +
      '<video src="' +
      escapeHtml(data.videoUrl) +
      '" loop muted playsinline preload="metadata" onloadedmetadata="csVideoShowFirstFrame(this)"></video>' +
      '<div class="cs-media-text__controls">' +
      '<button type="button" class="cs-media-text__mute" aria-label="Toggle mute" onclick="toggleCsVideoMute(this)">' +
      '<img class="cs-speaker-icon" src="' +
      escapeHtml(speakerIconUrl) +
      '" alt="" style="display:none">' +
      '<img class="cs-mute-icon" src="' +
      escapeHtml(muteIconUrl) +
      '" alt="">' +
      "</button>" +
      '<button type="button" class="cs-media-text__fullscreen" aria-label="Toggle full screen" onclick="toggleCsVideoFullscreen(this)">' +
      '<img class="cs-fullscreen-icon" src="' +
      escapeHtml(fullScreenIconUrl) +
      '" alt="">' +
      "</button>" +
      "</div>" +
      '<div class="cs-media-text__play" onclick="event.stopPropagation(); toggleCsVideo(this)"><svg class="cs-play-icon" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg><svg class="cs-pause-icon" viewBox="0 0 24 24" fill="white" style="display:none"><rect x="5" y="3" width="4" height="18"/><rect x="15" y="3" width="4" height="18"/></svg></div>' +
      (videoTitle
        ? '<span class="cs-media-text__media-title">' +
          escapeHtml(videoTitle) +
          "</span>"
        : "") +
      "</div>"
    : "";
  const contentHtml = hasText
    ? '<div class="cs-media-text__content">' +
      (data.title
        ? '<h3 class="cs-media-text__title">' + escapeHtml(data.title) + "</h3>"
        : "") +
      (data.description
        ? '<p class="cs-media-text__description">' +
          escapeHtml(data.description) +
          "</p>"
        : "") +
      "</div>"
    : "";

  const inner =
    data.layout === "left" ? mediaHtml + contentHtml : contentHtml + mediaHtml;
  return '<div class="cs-media-text ' + layoutClass + '">' + inner + "</div>";
};
